import {
  EntityAboutCard,
  EntityHasSubcomponentsCard,
  EntityLayout
} from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import React from 'react';
import { EntityContentWrapper } from '../../components/catalog';
import { Grid } from '@material-ui/core';
import { EntityTechdocsContent } from '@backstage/plugin-techdocs';

const OverviewContent = () => {
  return (<EntityContentWrapper>
    <Grid item md={6}>
      <EntityAboutCard />
    </Grid>
    <Grid item md={6} xs={12}>
      <EntityHasSubcomponentsCard />
    </Grid>
  </EntityContentWrapper>);
}

const RelationshipContent = () => {
  return (<EntityContentWrapper>
    <Grid item xs={12}>
      <EntityCatalogGraphCard height={400}
        kinds={['system', 'component', 'group', 'resource']}
        unidirectional
      />
    </Grid>
  </EntityContentWrapper>);
}

export const DefaultEntityPage = () => {
  return (<EntityLayout UNSTABLE_contextMenuOptions={{ disableUnregister: 'hidden' }}>
    <EntityLayout.Route path="/" title="Overview">
      <OverviewContent />
    </EntityLayout.Route>
    <EntityLayout.Route path="/relationships" title="Relationships">
      <RelationshipContent />
    </EntityLayout.Route>
    <EntityLayout.Route path="/docs" title="Docs">
      <EntityTechdocsContent />
    </EntityLayout.Route>
  </EntityLayout>);
}
